<template>
  <div class="inputMultiselect" :class="!isValid ? 'notValid' : ''" >
    <div class="labelForm" v-if="item.label">{{item.label || 'Testo Label'}}</div>
    <div>
      <multiselect :class="{ hasFocus: hasFocus }" ref="multi" v-model="value" :options="dataSourceView" track-by="codice" label="descrizione"
        :placeholder="item.placeHolder || ''" :multiple="false"
        :selectLabel="'Seleziona'" :selectedLabel="'Selezionato'" :deselectLabel="'Rimuovi'"
        :noResult="'Nessun risultato'" @open="onFocus" @close="onClose" @select="onSelect" @remove="onRemoveSelection"
        :close-on-select="true" :disabled="item.readonly"
        >
        <span slot="noResult">Nessun risultato</span>
        <span slot="noOptions">{{ item.noOptionsLabel || 'Non ci sono voci' }}</span>
        <template slot="option" slot-scope="props">
          <div class="option__desc">
            <div class="optionSelectedNotCheck optionMultiselect" ></div>
            <div class="optionSelectedCheck optionMultiselect"></div>
            <span class="option__title">{{ props.option.descrizione }}</span>
            <div v-if="item.extraOptionLabel" style="margin-left:1vh" v-html="item.extraOptionLabel(props)"></div>
            <!-- <div><div style='width:3vh;height:2vh;margin-left:1vh' class='azzurro'></div></div> -->
          </div>
        </template>

      </multiselect>
    </div>
    <span v-if="!isValid" class="labelErrore">{{ messaggioErrore || 'Valore non valido' }}</span>
    <div v-if="item.hint" class="labelHint">
      {{ item.hint }}
    </div>
  </div>
</template>

<script>
import { cloneObject } from '@/components/helpers'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import configurazioni from '@/services/configurazioniService.js'

export default {
  props: {
    item: Object,
    updateTrigger: Number
  },
  data() {
    return {
      hasFocus: false,
      isValid: true,
      messaggioErrore: '',
      value: null,
      dataSource: [],
      dataSourceView: []
    }
  },
  watch: {
    value(value) {
      this.$emit('update-value', this.getDati())
      this.$forceUpdate()
    },
    updateTrigger() {
      if (this.item.valore) {
        if (this.item.saveFormat === 'codice') {
          this.value = this.dataSource.find((obj) => { return obj.codice === this.item.valore })
        } else {
          this.value = this.item.valore
        }
      }
    }
  },
  async created() {
    if (Array.isArray(this.item.dataSource)) {
      this.dataSource = this.item.dataSource
    } else {
      var configName = this.item.dataSource.split('.')
      this.dataSource = await configurazioni.getConfigurazione(configName[0], configName[1])
    }
    this.dataSourceView = cloneObject(this.dataSource)
    if (this.item.valore) {
      if (this.item.saveFormat === 'codice') {
        this.value = this.dataSource.find((obj) => { return obj.codice === this.item.valore })
      } else {
        this.value = this.item.valore
      }
    }
  },
  mounted() {
    var self = this
    var currDeactivate = this.$refs.multi.deactivate

    this.$refs.multi.deactivate = function() {
      if (!self.hasFocus) {
        currDeactivate()
      }
    }
    this.$refs.multi.$el.children[0].onmousedown = function() {
      self.hasFocus = !self.hasFocus
      self.$refs.multi.toggle()
      self.onBlur()
    }
  },
  methods: {
    afterInit() {
      if (this.item.cascadeOn) {
        this.$emit('cascade-filter', { source: this.item, valore: this.value ? this.value.codice || null : null })
      }
    },
    onFocus(event) {
      console.log('on focus multiselect')
      this.hasFocus = true
      this.$emit('on-focus')
    },
    onClose(e) {
    },
    onBlur(event) {
      this.$emit('on-blur')
    },
    setFocus() {
      this.hasFocus = true
    },
    removeFocus() {
      this.hasFocus = false
      this.$refs.multi.$el.blur()
      this.$refs.multi.deactivate()
    },
    onKeyInput(value) {
      if (this.item.readonly) {
        return
      }
      if (value === '{space}') {
        value = ' '
      }
      var multi = this.$refs.multi
      if (value && value.length === 1) {
        multi.search += value
      } else if (value === '{backspace}' || value === '{bksp}') {
        if (multi.search.length > 0) {
          multi.search = multi.search.substring(0, multi.search.length - 1)
        }
      }
    },
    onSelect(obj) {
      if (this.item.cascadeOn) {
        this.$emit('cascade-filter', { source: this.item, valore: obj.codice })
      }
      this.onBlur()
      if (this.item.blurOnSelect) {
        this.hasFocus = false
        this.$refs.multi.deactivate()
      }
      var self = this
      setTimeout(() => {
        self.valida()
      }, 50)
    },
    onRemoveSelection() {
      var self = this
      setTimeout(() => {
        self.valida()
      }, 50)
    },
    valida() {
      if (!this.item.validations || !this.item.validations.length) {
        return []
      }
      var req = this.item.validations.find((obj) => obj.nome === 'required')
      var err = []
      if (req && !this.value) {
        this.isValid = false
        this.messaggioErrore = req.msgErrore || 'Selezionare una voce'
        err.push(this.messaggioErrore)
      } else {
        this.isValid = true
        this.messaggioErrore = ''
      }
      return err
    },
    getDati() {
      return this.item.saveFormat === 'codice' ? (this.value && this.value.codice) || null : this.value || null
    },
    filtraElementi(campo, valore) {
      var datiFiltrati = []
      for (var i = 0; i < this.dataSource.length; i++) {
        var d = this.dataSource[i]
        if (d[campo] === valore) {
          datiFiltrati.push(d)
        }
      }
      this.dataSourceView = datiFiltrati
      var currVal = this.value
      if (currVal && !datiFiltrati.find((obj) => { return obj.codice === currVal.codice })) {
        this.value = null
      }
    }
  }
}
</script>

<style scoped>
  .inputMultiselect >>> .multiselect {
    width: 90%;
  }

  .inputMultiselect >>> .multiselect__tags {
    height: 6vh;
    border-radius: 7px;
    padding: 10px;
    border: 2px solid #cccccc;
  }

   .inputMultiselect >>> .multiselect__content-wrapper{
     max-height: 200px !important;
   }

  .inputMultiselect >>> .multiselect__content-wrapper::-webkit-scrollbar{
    display: unset !important;
    width: 2vw;
  }

/*
  .inputMultiselect >>> .multiselect__content-wrapper::-webkit-scrollbar-track{
  }*/

  .inputMultiselect >>> .multiselect__content-wrapper::-webkit-scrollbar-thumb{
    background: #666666;
    border-radius: 10px;
  }

  .inputMultiselect >>> .multiselect__content-wrapper::-webkit-scrollbar-thumb:hover{
    background: #666666;
  }

  .inputMultiselect >>>  .multiselect__option--selected.multiselect__option--highlight{
    background: unset;
    color: unset;
  }

  .inputMultiselect >>> .multiselect__option--highlight {
    background: unset;
    outline: unset;
    color: unset;
  }

  .inputMultiselect >>> :not(.multiselect__option--selected) > .option__desc > .optionSelectedCheck {
    display: none;
  }

  .inputMultiselect >>> .multiselect__option--selected > .option__desc > .optionSelectedNotCheck {
    display: none;
  }

  .inputMultiselect >>> .multiselect__option:after{
    content: unset;
  }

  .inputMultiselect >>> .multiselect__content-wrapper{
     box-shadow: 12px 12px 10px #9c9c9c;
  }

  .inputMultiselect >>> .multiselect__placeholder,
  .inputMultiselect >>> .multiselect__input,
  .inputMultiselect >>> .multiselect__single
  {
    font-size: 3vh;
    font-weight: bold;
    line-height: inherit;
  }

  .inputMultiselect >>> .option__desc {
    display: flex;
    align-items: center;
  }

  .inputMultiselect >>> .optionMultiselect {
    width: 2vh;
    height: 2vh;
    margin-right: 5px;
    background-color: #fff;
    border-radius: 100%;
    border: 3px solid #949494;
    box-shadow: 0 3px 1px 0 rgb(0 0 0 / 5%), 0 2px 2px 0 rgb(0 0 0 / 10%), 0 3px 3px 0 rgb(0 0 0 / 5%);
  }

  .inputMultiselect >>> .optionSelectedCheck {
    background-color: orange;
  }

  .inputMultiselect >>> .optionSelectedCheck {
    background-color: orange;
  }

  .inputMultiselect >>> .option__title {
    font-size: 2vh;
  }

  .inputMultiselect >>> .multiselect__placeholder {
    color: #757575;
  }

  .inputMultiselect >>> .multiselect__select {
    z-index:9;
  }
</style>
